import React, { useState } from "react";
import Button from "../../../components/Common/Button/Button";
import classes from "./DistributeButton.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { distributeClassesActionHandler } from "../../../store/actions/actionHandlers/distributeActionHandler";
import { useNavigate } from "react-router";
import { distribute } from "../../../utils/mainTabs/distribute/distribute";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { errorTypes } from "../../../utils/errorTypes";
import { FormattedMessage } from "react-intl";

const DistributeButton = ({
  selectedUserGroup,
  resetForm,
  selectedUser,
  tenantName,
  distributedTo,
  isDirty,
  setLoading,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loader, setLoader] = useState(false);
  const distributeState = useSelector((state) => state.distributeReducer);
  const { selctedShotclassData, selctedSeriesData } = distributeState;

  const handleSubmit = () => {
    if (selctedShotclassData?.length > 0 || selctedSeriesData?.length > 0) {
      const data = {
        CategoryHierarchy: "",
        ClassGroups: selctedShotclassData?.concat(selctedSeriesData),
        DistributedTo: distributedTo,
        SelectedUsers: selectedUser ? selectedUser : [],
        TagExpression: {
          Category: "",
          CityId: null,
          CountryId: null,
          CountyId: null,
          StateId: null,
          StoreId: null,
        },
        UserGroups: selectedUserGroup ? selectedUserGroup : [],
      };
      dispatch(
        distributeClassesActionHandler(
          data,
          setLoader,
          navigate,
          tenantName,
          setLoading
        )
      );
    } else {
      dispatch(
        setErrorHandler(
          errorTypes?.WARN,
          <FormattedMessage id="DISTRIBUTE_DISTSELECTCLASS_MSG" />
        )
      );
    }
  };
  return (
    <div className={classes.distribute_button}>
      {isDirty ? (
        <span className={classes.clear} onClick={() => resetForm()}>
          <FormattedMessage id="RESET_MSG" />
        </span>
      ) : (
        <span
          className={classes.clear}
          onClick={() => navigate(distribute.classPath(tenantName))}
        >
          <FormattedMessage id="CANCEL_TEXT" />
        </span>
      )}
      <Button
        type="submit"
        label={<FormattedMessage id="Distribute" />}
        small
        dark
        onClick={handleSubmit}
        backgroundColor={loader ? undefined : "#D31B61"}
        loading={loader}
        disabled={
          selectedUserGroup?.length <= 5 && selectedUserGroup?.length > 0
            ? false
            : selectedUser?.length > 0
            ? false
            : true
        }
      />
    </div>
  );
};

export default DistributeButton;
